export { getCurrentUser } from 'next-flight-server-reference-proxy-loader?id=00f6ae2a0a3f18369002deae9bb64398e342d4b0b3&name=getCurrentUser!'